import { createContext, useLayoutEffect, useRef, useState } from "react";

export const QuestionsPageContext = createContext({});
export default function QuestionsPageProvider({ children }) {
  const asideRef = useRef(null);
  const articleRef = useRef(null);
  const [order, setOrder] = useState(null);
  const [period, setPeriod] = useState("year");

  const [selectedTag, setSelectedTag] = useState(null);
  useLayoutEffect(() => {
    const aside = asideRef.current;
    const article = articleRef.current;

    if (aside && article) {
      let resizeObserverTimeout;

      const updateStyles = () => {
        clearTimeout(resizeObserverTimeout);
        resizeObserverTimeout = setTimeout(() => {
          document.documentElement.style.setProperty("--aside-height", `${aside.offsetHeight}px`);
          document.documentElement.style.setProperty("--article-width", `${article.clientWidth}px`);
        }, 0);
      };

      const resizeObserver = new ResizeObserver(() => {
        updateStyles();
      });

      resizeObserver.observe(aside);
      resizeObserver.observe(article);

      updateStyles();

      return () => {
        clearTimeout(resizeObserverTimeout);
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <QuestionsPageContext.Provider
      value={{ asideRef, articleRef, order, setOrder, period, setPeriod, setSelectedTag, selectedTag }}>
      {children}
    </QuestionsPageContext.Provider>
  );
}
